module.exports = __webpack_public_path__ + "static/media/icon-battery.da20219b.svg";